module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-5"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toctitle"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "cont1_2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Chapter_1"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Preface")])])]), _vm._v(" "), _c('h2', {
    staticClass: "cont1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Chapter_2"
    }
  }, [_c('span', {
    staticClass: "bold hn_g"
  }, [_vm._v("Chapter 1")]), _vm._v(" John Fairley")])]), _vm._v(" "), _c('h2', {
    staticClass: "cont1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter_3"
    }
  }, [_c('span', {
    staticClass: "bold hn_g"
  }, [_vm._v("Chapter 2")]), _vm._v(" Clive Jones")])]), _vm._v(" "), _c('h2', {
    staticClass: "cont1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter_4"
    }
  }, [_c('span', {
    staticClass: "bold hn_g"
  }, [_vm._v("Chapter 3")]), _vm._v(" Graham Ironside")])]), _vm._v(" "), _c('h2', {
    staticClass: "cont1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold hn_g"
  }, [_vm._v("Chapter 4")]), _vm._v(" Kathryn Apanovicz")])]), _vm._v(" "), _c('h2', {
    staticClass: "cont1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold hn_g"
  }, [_vm._v("Chapter 5")]), _vm._v(" John Wilford")])]), _vm._v(" "), _c('h2', {
    staticClass: "cont1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold hn_g"
  }, [_vm._v("Chapter 6")]), _vm._v(" Keith Richardson")])]), _vm._v(" "), _c('h2', {
    staticClass: "cont1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold hn_g"
  }, [_vm._v("Chapter 7")]), _vm._v(" Alan Plater")])]), _vm._v(" "), _c('h2', {
    staticClass: "cont1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter_9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold hn_g"
  }, [_vm._v("Chapter 8")]), _vm._v(" John Willis")])]), _vm._v(" "), _c('h2', {
    staticClass: "cont1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter_10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold hn_g"
  }, [_vm._v("Chapter 9")]), _vm._v(" Grant McKee")])]), _vm._v(" "), _c('h2', {
    staticClass: "cont1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter_11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold hn_g"
  }, [_vm._v("Chapter 10")]), _vm._v(" Peter Kosminsky")])]), _vm._v(" "), _c('h2', {
    staticClass: "cont1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter_12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold hn_g"
  }, [_vm._v("Chapter 11")]), _vm._v(" David Green")])]), _vm._v(" "), _c('h2', {
    staticClass: "cont1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter_13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold hn_g"
  }, [_vm._v("Chapter 12")]), _vm._v(" Nick Gray")])]), _vm._v(" "), _c('h2', {
    staticClass: "cont1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter_14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold hn_g"
  }, [_vm._v("Chapter 13")]), _vm._v(" Marylyn Webb")])]), _vm._v(" "), _c('h2', {
    staticClass: "cont1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter_15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold hn_g"
  }, [_vm._v("Chapter 14")]), _vm._v(" Vernon Lawrence")])]), _vm._v(" "), _c('h2', {
    staticClass: "cont1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter_16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold hn_g"
  }, [_vm._v("Chapter 15")]), _vm._v(" Robert Charles")])]), _vm._v(" "), _c('h2', {
    staticClass: "cont1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter_17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold hn_g"
  }, [_vm._v("Chapter 16")]), _vm._v(" Talking of Sid Waddell")])]), _vm._v(" "), _c('h2', {
    staticClass: "cont1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter_18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold hn_g"
  }, [_vm._v("Chapter 17")]), _vm._v(" Meet the Stars")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-6"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "cont1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter_19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold hn_g"
  }, [_vm._v("Chapter 18")]), _vm._v(" David Taylor")])]), _vm._v(" "), _c('h2', {
    staticClass: "cont1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter_20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold hn_g"
  }, [_vm._v("Chapter 19")]), _vm._v(" Simon Welfare")])]), _vm._v(" "), _c('h2', {
    staticClass: "cont1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter_21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold hn_g"
  }, [_vm._v("Chapter 20")]), _vm._v(" David Taylor")])]), _vm._v(" "), _c('h2', {
    staticClass: "cont1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter_22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold hn_g"
  }, [_vm._v("Chapter 21")]), _vm._v(" Miriam Stoppard")])]), _vm._v(" "), _c('h2', {
    staticClass: "cont1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter_23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold hn_g"
  }, [_vm._v("Chapter 22")]), _vm._v(" Chris Jelley")])]), _vm._v(" "), _c('h2', {
    staticClass: "cont1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter_24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold hn_g"
  }, [_vm._v("Chapter 23")]), _vm._v(" Some YTV People")])]), _vm._v(" "), _c('h2', {
    staticClass: "cont1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter_25",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Epilogue")])])]), _vm._v(" "), _c('h2', {
    staticClass: "cont2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter_26",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Afterthought")])])]), _vm._v(" "), _c('h2', {
    staticClass: "cont2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter_27",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Appendix")])])]), _vm._v(" "), _c('h2', {
    staticClass: "cont2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_back1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Acknowledgements")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 66
// module chunks = 0